import { ReactElement } from 'react';
import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ListRegister from 'civil-status/components/shared/list-register';
import ListTypeContent from 'civil-status/components/shared/list-type-content';
import { ResearchReportVM } from 'civil-status/view-models/research-report';
import ListStateAct from 'civil-status/components/shared/list-state-research';
import OperatorList from 'civil-status/components/shared/operator-list';
import ListService from 'shell/components/shared/list-service';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<ResearchReportVM>();

  const onChangeRegister = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('idCat', event.target.value);
  });

  const onChangeTypeContent = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('typeContent', event.target.value);
  });

  const onChangeState = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('state', event.target.value);
  });

  const onChangeOperator = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('codOperator', event.target.value);
  });

  const onChangeService = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('service', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={2}>
        <ListRegister
          value={formContext.values.idCat || ''}
          error={Boolean(formContext.errors.idCat) && formContext.touched.idCat}
          onChange={onChangeRegister}
          disabled={formContext.values.disabledIdCat}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <ListTypeContent
          value={formContext.values.typeContent || ''}
          error={Boolean(formContext.errors.typeContent) && formContext.touched.typeContent}
          onChange={onChangeTypeContent}
          isWithAttiETrascrizioni
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <ListStateAct
          value={formContext.values.state || ''}
          error={Boolean(formContext.errors.state) && formContext.touched.state}
          onChange={onChangeState}
          isWithAnnotation
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <OperatorList
          onChange={onChangeOperator}
          value={formContext.values.codOperator || ''}
          codiceStatoEvento={formContext.values.state || undefined}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListService
          value={formContext.values.service || ''}
          onChange={onChangeService}
          label="Servizio"
          codService="AQ"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data inizio"
          aria-label="Data inizio"
          value={formContext.values.dateStart || null}
          onChange={(value) => {
            if (formContext.values.dateEnd) {
              formContext.setFieldValue('dateStart', value);
              return;
            }

            formContext.setValues({
              ...formContext.values,
              dateStart: value,
              dateEnd: value,
            });
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateStart"
              fullWidth
              error={formContext.touched?.dateStart && Boolean(formContext.errors?.dateStart)}
              helperText={formContext.errors?.dateStart}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data fine"
          aria-label="Data fine"
          value={formContext.values.dateEnd || null}
          onChange={(value) => formContext.setFieldValue('dateEnd', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateEnd"
              fullWidth
              error={formContext.touched?.dateEnd && Boolean(formContext.errors?.dateEnd)}
              helperText={formContext.errors?.dateEnd}
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Pulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="secondary" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Practice Research - Filter Practice - Form Filter component';

export default FormFilter;
